import Tooltip from '../Tooltip/Tooltip';

import { Props } from './types';

/**
 * @deprecated Do not use this component. There is no equivalent yet at the root
 * of the UI folder — a new version should be built there using the current
 * design-system patterns (tailwind-variants + Headless UI, see src/ui/Button)
 * instead of using this legacy component.
 */
const ImageTooltip = ({
  imageUrl,
  label,
  tooltipAlt = label,
  linkClassName = 'text-blue-800',
  fallbackClassName = 'text-gray-600'
}: Props) => {
  return imageUrl ? (
    <Tooltip
      tooltipContent={<img loading="lazy" src={imageUrl} alt={tooltipAlt} className="w-50" />}>
      <a className={linkClassName} target="_blank" rel="noreferrer" href={imageUrl}>
        {label}
      </a>
    </Tooltip>
  ) : (
    <span className={fallbackClassName}>No {label}</span>
  );
};

export default ImageTooltip;
